import { api } from './api';

// Define a service using a base URL and expected endpoints for AI models
export const aiModelApi = api.injectEndpoints({
  reducerPath: 'aiModelApi',
  tagTypes: ['AiModels'],
  endpoints: (builder) => ({
    getAiModels: builder.query({
      query: () => ({
        url: `/api/administration/models`,
        method: 'GET'
      }),
      providesTags: ['AiModels']
    }),
    getAiModelById: builder.query({
      query: (id) => ({
        url: `/api/administration/models/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'AiModels', id }]
    }),
    getModelsByProvider: builder.query({
      query: (providerId) => ({
        url: `/api/administration/models/provider/${providerId}`,
        method: 'GET'
      }),
      providesTags: (result, error, providerId) => [{ type: 'AiModels', providerId }, 'AiModels']
    }),
    createAiModel: builder.mutation({
      query: (aiModelRequest) => ({
        url: `/api/administration/models`,
        method: 'POST',
        body: aiModelRequest
      }),
      invalidatesTags: ['AiModels']
    }),
    updateAiModel: builder.mutation({
      query: ({ id, aiModelRequest }) => ({
        url: `/api/administration/models/${id}`,
        method: 'PATCH',
        body: aiModelRequest
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'AiModels', id }, 'AiModels']
    }),
    deleteAiModel: builder.mutation({
      query: (id) => ({
        url: `/api/administration/models/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [{ type: 'AiModels', id }, 'AiModels']
    }),
    bulkDeleteAiModels: builder.mutation({
      query: (ids) => ({
        url: `/api/administration/models`,
        method: 'DELETE',
        body: ids
      }),
      invalidatesTags: ['AiModels']
    }),
    toggleFavorite: builder.mutation({
      query: (id) => ({
        url: `/api/administration/models/${id}/favorite`,
        method: 'PATCH'
      }),
      invalidatesTags: (result, error, id) => [{ type: 'AiModels', id }, 'AiModels']
    }),
    getFavoriteModels: builder.query({
      query: () => ({
        url: `/api/administration/models/favorites`,
        method: 'GET'
      }),
      providesTags: ['AiModels']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAiModelsQuery,
  useGetAiModelByIdQuery,
  useGetModelsByProviderQuery,
  useCreateAiModelMutation,
  useUpdateAiModelMutation,
  useDeleteAiModelMutation,
  useBulkDeleteAiModelsMutation,
  useToggleFavoriteMutation,
  useGetFavoriteModelsQuery
} = aiModelApi;
